import React from "react";
import { useCookieConsent } from "../contexts/CookieConsentContext";
import "./CookieConsent.css";

const CookieConsent: React.FC = () => {
    const { isConsentGiven, acceptAnalytics, rejectAnalytics } = useCookieConsent();

    if (isConsentGiven) return null;

    return (
        <>
        <div className="cookie-consent-overlay" aria-hidden="true" />
        <div className="cookie-consent-banner" role="dialog" aria-label="Informacja o plikach cookies">
            <div className="cookie-consent-content">
                <p className="cookie-consent-heading">Ta strona przechowuje dane na Twoim urządzeniu:</p>
                <ul className="cookie-consent-list">
                    <li>
                        <strong>Niezbędne</strong> — dane konieczne do prawidłowego działania aplikacji,
                        m.in. dane konta i preferencje użytkownika. Nie wymagają zgody.
                    </li>
                    <li>
                        <strong>Analityczne (cookies Google Analytics)</strong> — pliki cookies służące do analizy ruchu
                        i poprawy jakości usług. Są opcjonalne i wymagają Twojej zgody.{" "}
                        <a href="https://support.google.com/analytics/answer/6004245" target="_blank" rel="noopener noreferrer">Dowiedz się więcej</a>.
                    </li>
                </ul>
                <p className="cookie-consent-question">Czy wyrażasz zgodę na analityczne pliki cookies?</p>
            </div>
            <div className="cookie-consent-buttons">
                <button className="cookie-consent-reject" onClick={rejectAnalytics}>
                    Odrzuć
                </button>
                <button className="cookie-consent-accept" onClick={acceptAnalytics}>
                    Akceptuję
                </button>
            </div>
        </div>
        </>
    );
};

export default CookieConsent;
